<template>
  <b-modal
    v-model="localActive"
    id="bv-modal-notification"
    hide-footer
    centered
    size="xl"
  >
    <div class="modal-body">
      <div id="modal-prioritarias-chart">
        <div class="modal-body-title">
          <h4>
            <strong>{{ item?.no_escola }}</strong>
          </h4>
          <p>
            {{ quantidadeAtividadesRealizadas }} atividades de
            <strong>"{{ atividade }}"</strong>
            realizadas
          </p>
        </div>
        <apexchart
          type="bar"
          height="350"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </div>
  </b-modal>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    series: {
      type: Array,
      default: () => [],
    },
    active: {
      type: [Boolean],
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    tipoAtividade: {
      type: String,
      default: '',
    },
    atividade: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
        },
        colors: ['#e68a00', '#008000', '#ff0000'],
        plotOptions: {
          bar: {
            borderRadius: 4,
            borderRadiusApplication: 'end',
            horizontal: true,
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [
            ['Estimativa', 'de Estudantes'],
            ['Estudantes', 'participantes', 'da atividade'],
            ['Estimativa', 'de estudantes', 'ainda não atendidos'],
          ],
        },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            // const label = categories[dataPointIndex].join(' ')
            const value = series[seriesIndex][dataPointIndex]
            return `<div class="apex-tooltip">
                 <strong>${value}</strong>
              </div>`
          },
        },
      },
    }
  },
  computed: {
    localActive: {
      get() {
        return this.active
      },
      set(val) {
        this.$emit('update:active', val)
      },
    },
    quantidadeAtividadesRealizadas() {
      switch (this.tipoAtividade) {
        case 'alimentacao':
          return this.item.qtd_atvds_alimentacao
          break
        case 'paz':
          return this.item.qtd_atvds_paz
          break
        case 'reproducao':
          return this.item.qtd_atvds_reproducao
          break
        case 'mental':
          return this.item.qtd_saude_mental
          break
        case 'vacinacao':
          return this.item.qtd_atvds_vacinacao
          break
        default:
          return ''
          break
      }
    },
  },
}
</script>

<style lang="scss">
#modal-prioritarias-chart {
  .modal-body-title {
    text-align: center;
  }
  .apex-tooltip {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 10px;
    font-size: 13px;
    color: #333;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    max-width: 200px;
    white-space: normal;
    hr {
      margin: 5px 0;
    }
  }
}
</style>
